import List from 'containers/Niches/List';
import Edit from 'containers/Niches/Edit';
import Create from 'containers/Niches/Create';
import Show from 'containers/Niches/Show';

export default { List, Edit, Create, Show };
